import { JIRA_SOFTWARE } from '@jira/platform__application-editions/src/application.tsx';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { useExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { useExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const EXPERIENCE_NAME = 'removeIssueFromVersion';
const ANALYTICS_SOURCE = 'versionDetails';

export const useRemoveIssueFromVersionExperienceStart = () => {
	const appEditions = useAppEditions();
	return useExperienceStart({
		experience: EXPERIENCE_NAME,
		experienceId: `${Date.now()}`,
		analyticsSource: ANALYTICS_SOURCE,
		application: JIRA_SOFTWARE,
		edition: appEditions.software,
	});
};

export const useRemoveIssueFromVersionExperienceFail = () =>
	useExperienceFail({
		experience: EXPERIENCE_NAME,
	});

export const useRemoveIssueFromVersionExperienceSuccess = () =>
	useExperienceSuccess({
		experience: EXPERIENCE_NAME,
	});
